const errorEmail = 'Le champ doit contenir un e-mail valide';

export default {
  actions: {
    search: 'Chercher',
    sendTokenAsign: 'Recherche de jeton à responsable',
    selectSearch: "Rechercher l'éditeur",
    exactSearch: 'Recherche exacte',
    optionsSearch: 'Type de filtrage',
    selectedSearch: 'Fields sélectionnés',
    detail: 'Détail',
    delete: 'Retirer',
    saveExit: 'Sauvegarder et quitter',
    save: 'Sauvegarder',
    add: 'Ajouter',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    edit: 'Éditer',
    editRoot: 'Modifier la racine',
    request_update: 'Demande de changement',
    activate: 'Activer',
    deactivate: 'Désactiver',
    select_one: 'Sélectionner ...',
    moreActions: "Plus d'actions",
    exportCSV: 'Exporter vers CSV',
    disable: 'Désinscription',
    enable: 'Récupérer',
    addOther: 'Ajouter un autre',
    addLocation: 'Ajouter un emplacement',
    exportPDF: 'Exporter vers PDF',
    custodyVoucher: 'Bon de garde',
    exportPDFprice: 'Exporter en PDF avec prix',
    accept: 'Accepter',
    reject: 'Déclin',
    noDischarged: 'Pas déchargé',
    discharged: 'Déchargé',
    all: 'Tous les',
    noChangesToReview: 'Aucun changements à revoir',
    changesToReview: 'Changements à revoir',
    qr_url: 'URL QR',
    qr_name: 'Nom QR',
    qr_info: 'Information QR',
    barcode: 'Code à barres',
    regenerateCodes: 'Régénérer les codes',
  },
  common: {
    files: 'Cliquez pour sélectionner vos fichiers ou les glisser ici',
    filesActive: 'Libérez les fichiers',
    filesLimits: (size, acepted) =>
      `Cliquez pour sélectionner vos fichiers ou les glisser ici \nPoids maximal: ${size}\nFormats pris en charge: ${acepted}`,
    file: 'Cliquez pour sélectionner le fichier ou le faire glisser ici',
    fileActive: 'Libérez le fichier',
    actions: 'Actions',
    error: 'Erreur',
    success: 'Succès',
    status: 'Statut',
    active_male: 'Actif',
    active_female: 'Actif',
    deactivated_male: 'Handicapé',
    deactivated_female: 'Désactiver',
    yes: 'Oui',
    no: 'Non',
    loading: 'Mise en charge',
  },

  months: {
    1: 'Jan.',
    2: 'Fév.',
    3: 'Mer.',
    4: 'Avr.',
    5: 'Peut.',
    6: 'Jun.',
    7: 'Juil.',
    8: 'Août',
    9: 'Sep.',
    10: 'Oct.',
    11: 'Nov.',
    12: 'Déc.',
  },

  success: {
    custody_voucher_saved:
      'Le bon de garde signé a été enregistré dans les fichiers de l’actif.',
    employee_custody_voucher_saved:
      'Le bon de garde signé a été enregistré dans les fichiers de chaque bien du dépositaire.',
    recover_password:
      'Si vous avez entré correctement votre e-mail, nous vous enverrons les instructions pour récupérer votre mot de passe.',
    reset_password: 'Votre mot de passe a été mis à jour, maintenant vous pouvez vous connecter.',
    token_send: "Le jeton d'attribution d'actifs a été envoyé avec succès.",
    toggle_company: "L'entreprise a été mise à jour.",
    delete_company: "L'entreprise a été éliminée.",
    create_company: "L'entreprise a été ajoutée.",
    edit_company: "L'entreprise a été modifiée.",
    add_user: "L'utilisateur a été ajouté",
    toggle_user: "L'utilisateur a été mis à jour",
    update_user: "L'utilisateur a été mis à jour",
    add_notification_config: 'Le profil de notification a été ajouté',
    toggle_notification_config: 'Le profil de notification a été mis à jour',
    update_notification_config: 'Le profil de notification a été mis à jour',
    add_role: 'Le rôle a été ajouté',
    update_role: 'Le rôle a été mis à jour',
    complete_info: 'Vous avez terminé vos informations, maintenant vous pouvez vous connecter',
    create_subcompany: "L'entreprise a été ajoutée.",
    edit_subcompany: "L'entreprise a été modifiée.",
    toggle_subcompany: "L'entreprise a été mise à jour.",
    delete_subcompany: "L'entreprise a été éliminée.",
    add_asset: "L'actif a été ajouté.",
    update_asset: "L'actif a été modifié.",
    disable_asset: "L'actif a été libéré.",
    enable_asset: "L'actif s'est rétabli.",
    import_assets: 'Des actifs ont été importés.',
    import: 'Les données ont été importées.',
    toggle_account: "L'inscription a été mise à jour.",
    update_account: "L'inscription a été mise à jour.",
    add_account: "L'inscription a été ajoutée.",
    toggle_depreciation: "L'amortissement a été mis à jour.",
    update_depreciation: "L'amortissement a été mis à jour.",
    add_depreciation: "L'amortissement a été ajouté.",
    toggle_cost_centers: 'Le centre de coûts a été mis à jour.',
    update_cost_centers: 'Le centre de coûts a été mis à jour.',
    add_cost_centers: 'Le centre de coûts a été ajouté.',
    toggle_inpc: 'INPC a été mis à jour',
    update_inpc: 'INPC a été mis à jour',
    add_inpc: 'INPC a été ajouté.',
    toggle_custom_group: 'Le groupe a été mis à jour.',
    update_custom_group: 'Le groupe a été mis à jour.',
    add_custom_group: 'Le groupe a été ajouté.',
    toggle_exchange: 'Le taux de change a été mis à jour.',
    update_exchange: 'Le taux de change a été mis à jour.',
    add_exchange: 'Le taux de change a été ajouté.',
    toggle_employee: "L'employé a été mis à jour.",
    update_employee: "L'employé a été mis à jour.",
    add_employee: "L'employé a été ajouté.",
    update_catalogs: 'Le catalogue a été mis à jour.',
    update_locations: 'Les emplacements ont été mis à jour.',
    add_project: 'Le projet a été ajouté.',
    update_project: 'Le projet a été mis à jour.',
    toggle_project: 'Le projet a été mis à jour.',
    toggle_providers_clients: 'Le fournisseur a été mis à jour.',
    update_providers_clients: 'Le fournisseur a été mis à jour.',
    add_providers_clients: 'Le fournisseur a été ajouté',
    accept_historic: 'Les changements ont été acceptés',
    reject_historic: 'Les changements ont été rejetés',
    request_update_asset:
      "Un enregistrement des modifications a été créé, qui doit être approuvé afin qu'ils puissent être reflétés dans l'actif modifié",
    asset_in: "J'entre actif",
    asset_out: 'Il est sorti actif',
    asset_needs_authorization: "La demande de sortie enregistrée, en attente d'autorisation",
    asset_authorized_out: "La sortie de l'actif était autorisée",
    asset_not_authorized_out: "La sortie de l'actif est rejetée",
  },
  error: {
    subcompany_forbidden: "Vous n'avez pas accès à cette sous-société.",
    custody_voucher: {
      file_required: 'Le PDF du bon n’a pas été reçu.',
      single_file: 'Envoyez un seul PDF.',
      too_large: 'Le PDF du bon dépasse 10 Mo.',
      bad_file_name: 'Le nom du fichier du bon n’est pas valide.',
      not_pdf: 'Le fichier du bon n’est pas un PDF.',
      no_custodian: 'L’actif n’a pas de dépositaire.',
      bad_employee: 'Le dépositaire du bon est manquant.',
      bad_assets: 'La liste des biens du bon n’est pas valide.',
      too_many_assets: 'Le bon couvre trop de biens (500 au maximum).',
      other_custodian: 'L’un des biens a un autre dépositaire.',
      inactive_asset: 'L’un des biens est inactif ou sorti.',
      incomplete:
        'Bon incomplet : il doit inclure tous les biens du dépositaire. ' +
        'Effacez la recherche et réessayez.',
      changed:
        'Les biens ont changé pendant l’enregistrement. Rien n’a été enregistré ; réessayez.',
    },
    asset_not_found: 'L’actif est introuvable.',
    employee_not_found: 'Le dépositaire est introuvable.',
    cannot_upload: 'Le fichier n’a pas pu être téléversé, réessayez.',
    download_image: "Impossible de télécharger l'image, veuillez réessayer",
    generate_pdf: "Impossible de générer le PDF de l'actif, veuillez réessayer",
    session_expired: 'Votre session a expiré',
    session_terminated: 'La session a commencé sur un autre appareil',
    verify: 'Vérifiez les champs',
    server_error:
      "Une erreur s'est produite lors de la communication avec le serveur, tentez plus tard",
    required: 'Ce champ est requis',
    format: 'Le format est invalide',
    minLength: 'Ce champ est requis',
    type: 'Ce champ est requis',
    email: errorEmail,
    bad_credentials: "Les données d'accès ne sont pas valides",
    bad_token: 'Le jeton a expiré ou a déjà été utilisé',
    company_not_found: "L'entreprise n'est pas trouvée ou est désactivée.",
    user_already_exists: 'Un utilisateur avec cet e-mail a déjà été ajouté',
    add_duplicate_key: 'La clé a déjà été utilisée',
    asset_already_in: "L'actif est déjà à l'intérieur",
    asset_already_out: "L'actif est déjà sorti",
    asset_is_in: "L'actif est à l'intérieur",
    asset_out_needs_message: 'Une modification est requise pour la retraite',
    asset_needs_authorization: "L'autorisation est tenue de procéder",
    asset_needs_asset_level: "Un niveau d'actif est requis",
    asset_needs_employee: "Vous avez besoin d'une personne responsable pour vous retirer",
    asset_can_not_withdraw: 'Il ne peut pas être retiré',
    asset: {
      limit_exceded: 'La limite des actifs attribués à cette entreprise',
      files_limit_exceded: 'La limite des fichiers actifs est excitée.',
      size_limit_exceded: 'Vérifiez que le format et le poids sont pris en charge.',
      dmsReference: {
        pattern: 'Doit contenir entre 8 et 10 caractères',
      },
    },
    login: {
      email: {
        format: errorEmail,
      },
      password: {
        required: 'Le champ doit contenir au moins 12 caractères',
        minLength: 'Le champ doit contenir au moins 12 caractères',
      },
    },
    users: {
      email: {
        format: errorEmail,
      },
      limit_exceded: "La limite d'administrateurs affectés à cette société a été dépassée",
      admin_role_forbidden: "Seul l'administrateur de la société peut attribuer ou modifier le rôle Administrateur.",
      subcompanies_forbidden: "Seul l'administrateur de la société peut attribuer des sous-sociétés.",
      subcompany_not_found: "L'une des sous-sociétés choisies n'existe plus dans la société.",
      subcompanies_not_saved: "Le serveur n'a pas enregistré les sous-sociétés. Vérifiez que le back-end est à jour et réessayez.",
      root_not_editable: "Les utilisateurs root ne se modifient pas depuis cet écran : ils voient toutes les sous-sociétés.",
    },
    recover_password: {
      email: {
        format: errorEmail,
      },
    },
    reset_password: {
      password: {
        minLength: 'Le mot de passe ne peut pas être si court',
      },
    },
    depreciation_fails: 'Ne pouvait pas calculer:',
    user_password_expired:
      'Votre mot de passe a expiré, nous vous avons envoyé un e-mail pour saisir un nouveau mot de passe.',
    asset_duplicated_number:
      'Le numéro que vous essayez de garder est déjà utilisé par un autre atout.',
  },
  info: {
    noResults: 'Aucun résultat trouvé',
  },
  login: {
    title: 'Commencer la session',
    subtitle: 'Nous sommes une entreprise spécialisée dans le contrôle des immobilisations.',
    fields: {
      email: 'Courrier électronique',
      password: 'Mot de passe',
      submit: 'Commencer la session',
      recovery: 'Vous avez oublié votre mot de passe?',
    },
  },
  recover_password: {
    title: 'Récupérer le mot de passe',
    subtitle: "Entrez l'e-mail avec lequel vous êtes enregistré.",
    fields: {
      email: 'Courrier électronique',
      submit: 'Envoyer',
      login: 'Retour pour connecter',
    },
  },

  reset_password: {
    title: 'Nouveau mot de passe',
    subtitle: 'Entrez votre nouveau mot de passe.',
    fields: {
      password: 'Mot de passe',
      submit: 'Envoyer',
      login: 'Retour pour connecter',
    },
  },

  complete_info: {
    title: 'Enregistrement complet',
    subtitle: 'Pour continuer à compléter les données suivantes, vous pouvez vous connecter.',
    fields: {
      name: 'Des nom',
      lastname: 'Nom de famille',
      password: 'Mot de passe',
      submit: 'Envoyer',
      login: 'Retour pour connecter',
    },
  },

  update_info: {
    title: 'Mettre à jour les données',
    subtitle: 'Pour continuer à compléter les données suivantes, vous pouvez vous connecter.',
    fields: {
      name: 'Des nom',
      lastname: 'Nom de famille',
      password: 'Mot de passe',
      submit: 'Envoyer',
      login: 'Retour pour connecter',
    },
  },

  acl: {
    companies: {
      edit: "Modifier les informations de l'entreprise",
    },
    users: {
      get: 'Lister et rechercher des utilisateurs',
      add: 'Ajouter des utilisateurs',
      update: 'Modifier les utilisateurs',
      toggle: 'Activer / désactiver les utilisateurs',
    },
    roles: {
      get: 'Listez et recherchez des rôles',
      add: 'Ajouter des rôles',
      update: 'Modifier les rôles',
      delete: 'Éliminer les rôles',
      toggle: 'Activer / désactiver les rôles',
    },
    groups: {
      get: 'Listez et recherchez des rôles',
      add: 'Ajouter des rôles',
      update: 'Modifier les rôles',
      delete: 'Éliminer les rôles',
      toggle: 'Activer / désactiver les rôles',
    },

    custom_employee_module: {
      get: 'Listez et recherchez les employés',
      add: 'Ajouter des employés',
      update: 'Modifier les employés',
      delete: 'Éliminer les employés',
      toggle: 'Activer / désactiver les employés',
    },

    custom_employee: {
      get: 'Listez et recherchez des champs personnalisés',
      add: 'Ajouter des champs personnalisés',
      update: 'Modifier les champs personnalisés',
      delete: 'Supprimer les champs personnalisés',
      toggle: 'Activer / désactiver les champs personnalisés',
    },

    custom_group: {
      get: 'Listez et recherchez des champs personnalisés',
      add: 'Ajouter un groupe de champs personnalisés',
      update: 'Modifier le groupe de champs personnalisés',
      delete: 'Supprimer le groupe de champs personnalisés',
      toggle: 'Activer / désactiver le groupe de champ personnalisé',
    },

    asset_level: {
      get: 'Lister et rechercher des actifs',
      add: "Ajouter un niveau d'actif",
      update: "Modifier le niveau d'actif",
      delete: 'Éliminez le niveau des actifs',
      toggle: "Activer / désactiver le niveau d'actif",
    },

    AssetsFilters: {
      showFilters: 'Afficher les filtres',
      hideFilters: 'Masquer les filtres',
    },

    assetsCustomsDocuments: {
      showForm: 'Afficher',
      hideForm: 'Cacher',
      pedimento_number: 'Numéro de pédimento',
      customs_key: 'Clé douanière',
      date: 'Date',
      import: 'Importation',
      quantity: 'Quantité',
      pedimento_key: 'Clé de pédimento',
      files: 'Fichiers',
      total_pedimentos: 'Total des pédimentos',
      accumulated_import: 'Importation accumulée',
      from: 'De',
      to: 'À',
      status: 'Statut',
      save: 'Sauvegarder',
      createdAt: 'Créé à',
    },

    ins_outs: {
      in: "Enregister des revenus d'actifs",
      out: 'Demander le retrait des avoirs',
      // resolve:"Modifier les billets et les sorties",
    },

    notification_historic: {
      get: "Voir l'histoire des notifications",
    },

    employees: {
      get: 'Listez et recherchez les employés',
      add: 'Ajouter des employés',
      update: 'Modifier les employés',
      delete: 'Éliminer les employés',
      toggle: 'Activer / désactiver les employés',
    },

    exchanges: {
      title: "Taux d'échange",
      get: 'Lister et rechercher des taux de change',
      add: 'Ajouter des taux de change',
      update: 'Modifier les taux de change',
      delete: 'Éliminer les taux de change',
    },

    inpc: {
      title: 'Inpc',
      get: "Listez et recherchez les INPC's",
      add: "Ajouter INPC's",
      update: "EDIT INPC's",
      delete: "Éliminer les INPC's",
    },

    projects: {
      get: 'Lister et rechercher des projets',
      add: 'Ajouter des projets',
      update: 'Modifier les projets',
      delete: 'Éliminer les projets',
      toggle: 'Activer/désactiver les projets',
    },

    assets: {
      get: 'Énumérez et recherchez des actifs fixes',
      add: 'Ajouter des actifs fixes',
      update: 'Modifier les immobilisations',
      delete: 'Éliminer les immobilisations',
      disable: 'Faible immobilier',
      enable: 'Récupérer les actifs fixes libérés',
      request_update: 'Demandez un changement dans un actif',
      review_request_update: 'Approuver / rejeter la modification demandée dans un actif',
    },

    cost_centers: {
      title: 'Centres Coster',
      get: 'Énumérer et rechercher les coûts',
      add: 'Ajouter des centres de coûts',
      update: 'Modifier les centres de coûts',
      delete: 'Supprimer les centres de coûts',
      toggle: 'Activer / désactiver les centres de coûts',
    },

    clients_providers: {
      get: 'Listez et recherchez des rôles',
      add: 'Ajouter des rôles',
      update: 'Modifier les rôles',
      delete: 'Éliminer les rôles',
    },

    catalogs: {
      get: 'Lister et rechercher des catalogues',
      update: 'Modifier les catalogues',
    },

    subcompanies: {
      get: 'Lister et rechercher des entreprises',
      add: 'Ajouter des entreprises',
      update: 'Modifier les entreprises',
      delete: 'Supprimer les entreprises',
      toggle: 'Activer / désactiver les entreprises',
    },

    accounts: {
      get: "Énumérez et recherchez des comptes et des types d'actifs",
      add: "Ajouter des comptes et des types d'actifs",
      update: "Modifier les comptes et les types d'actifs",
      delete: "Éliminer les comptes et les types d'actifs",
      toggle: "Activer / désactiver les types d'actifs",
    },

    depreciations: {
      get: "Énumérez et recherchez l'amortissement",
      add: 'Ajouter la dépréciation',
      update: 'Modifier la dépréciation',
      delete: "Éliminer l'amortissement",
      toggle: 'Activer / désactiver la dépréciation',
    },

    providers_clients: {
      get: 'Lister et rechercher des fournisseurs',
      add: 'Ajouter des fournisseurs',
      update: 'Modifier les fournisseurs',
      delete: 'Éliminer les fournisseurs',
      toggle: 'Activer / désactiver les fournisseurs',
    },

    reports: {
      disabled: "Consulter le rapport 'Active Dwarks'",
      depreciation: "Consulter le rapport 'Amortissement des immobilisations'",
      employees_assets: 'Bons de prosedo',
      historics: 'Histoire des actifs',
      ins_outs: 'Entrées et sorties',
    },

    import: {
      import: "Il permet d'importer des actifs via un fichier CSV",
    },

    locations: {
      get: 'Lister les emplacements',
      update: 'Mise à jour les emplacements',
    },

    mantenimiento_module: {
      get: 'Répertoriez et recherchez les actifs de maintenance',
    },

    mantenimiento: {
      get: 'Répertoriez et recherchez les actifs de maintenance',
      add: 'Ajouter à la maintenance',
      update: 'Modifier la maintenance',
      toggle: 'Activer / désactiver la maintenance',
    },
    notifications_config: {
      get: 'Répertoriez et recherchez les configurations de notification',
      add: 'Ajouter à la configuration de la notification',
      update: 'Modifier le profil de notification',
      toggle: 'Activer / désactiver le profil de notification',
    },
    notification_historic: {
      get: 'Listez et recherchez des notifications',
    },
    asset_level: {
      get: 'Lister et rechercher des actifs',
      add: 'Ajouter au niveau actif',
      update: "Modifier le niveau d'actif",
      delete: 'Éliminez le niveau des actifs',
      toggle: "Activer / désactiver le niveau d'actif",
    },
    ins_outs: {
      in: "Enregistrer des revenus d'actifs",
      out: 'demander le retrait des avoirs',
      resolve: 'Résoudre une sortie active',
    },
    custom_employee: {
      get: 'Lister et rechercher des champs personnalisés',
      add: 'Ajouter des champs personnalisés',
      update: 'Modifier les champs personnalisés',
      delete: 'Éliminer les champs personnalisés',
      toggle: 'Activer / désactiver les champs personnalisés',
    },
    custom_group: {
      get: 'Listez et recherchez des groupes de champs personnalisés',
      add: 'Ajouter des groupes de champs personnalisés',
      update: 'Modifier les groupes de champs personnalisés',
      delete: 'Éliminer les groupes de champs personnalisés',
      toggle: 'Activer / désactiver les groupes de champs personnalisés',
    },
  },
  ins_outs: { title: 'Entrées et sorties' },

  companies: {
    title: 'Entreprises',
    form_edit_title: 'Edit Company',
    form_add_title: 'Ajouter une entreprise',
    permissions: 'Rôle',
    delete_title: 'Supprimer la société',
    delete_confirm:
      "Voulez-vous vraiment supprimer l'entreprise <strong> {{name}} </strong>?* <br/><br/> <small>* L'action ne peut pas être annulée.</small>",
    typeService: 'Type de service',
    fields: {
      name: 'Nom',
      shortname: 'Nom court',
      adminsLimit: "Nombre d'utilisateurs admin par entreprise",
      assetsLimit: "Nombre d'actifs de l'entreprise",
      sizePerFile: 'Taille du fichier actif, en MB',
      filesPerAsset: 'Quantité de fichiers actifs',
      initDate: 'Date de début',
      endDate: 'Date de fin',
      salesAgentName: 'Nom de l agent de vente',
      salesAgentEmail: 'Courrier électronique de l agent de vente',
      isDemo: 'Démonstration de l entreprise',
    },
  },

  subcompanies: {
    none_assigned: "Vous n'avez aucune sous-société attribuée",
    title: 'Entreprises',
    form_edit_title: 'Edit Company',
    form_add_title: 'Ajouter une entreprise',
    delete_title: 'Supprimer la société',
    delete_confirm:
      "Voulez-vous vraiment supprimer l'entreprise <strong> {{name}} </strong>?* <br/><br/> <small>* L'action ne peut pas être annulée.</small>",
    fields: {
      name: 'Nom',
      shortname: 'Nom court',
    },
  },

  users: {
    title: 'Utilisateurs',
    subtitle: 'Utilisateurs',
    usersNotify: 'UTILISATEURS A NOTIFIER',
    form_edit_title: "Modifier l'utilisateur",
    form_add_title: 'Ajouter un utilisateur',
    fields: {
      name: 'Des nom',
      lastname: 'Nom de famille',
      email: 'Courrier électronique',
      roleId: 'Rôle',
      subcompanies: 'Sous-sociétés',
      all_subcompanies: 'Toutes',
      root_all_subcompanies: 'Utilisateur root : voit toutes les sous-sociétés.',
    },
    searchEditor: {
      name: 'Des nom',
      lastName: 'Nom de famille',
      email: 'Courrier électronique',
    },
  },

  roles: {
    title: 'Les rôles',
    subtitle: 'Les rôles',
    form_edit_title: 'Modifier le rôle',
    form_add_title: 'Ajouter un rôle',
    fields: {
      name: 'Nom',
      permissions: 'Permis',
      default: 'Par défaut',
    },
    permissions: {
      key: 'Mot de passe',
      description: 'La description',
    },
    searchEditor: {
      name: 'Nom',
    },
  },

  groups: {
    title: 'Groupes',
    subtitle: 'Groupes',
    form_edit_title: 'Edit Group',
    form_add_title: 'Ajouter un groupe',
    fields: {
      key: 'Clé',
      name: 'Nom',
      description: 'La description',
      module: 'Module',
      active: 'Actif',
      customs: 'Les champs personnalisés',
    },
    permissions: {
      key: 'Mot de passe',
      description: 'La description',
    },
    searchEditor: {
      key: 'Clé',
      name: 'Nom',
      description: 'La description',
      module: 'Module',
    },
    moduleDropDown: {
      employees: 'Salariés',
      centerCost: 'Centre de coût',
      providers: 'Fournisseurs',
      projects: 'Projets',
      typeAssets: "Type d'actifs",
      contableAccounts: 'Comptes comptables',
      depreciations: 'Amortissements',
      assets: 'Actif',
    },
  },

  pagination: {
    prev: '<',
    next: '>',
    show: 'Montrer',
    of: 'de',
    per_page: 'par page',
  },

  assets: {
    title: 'Actifs fixes',
    subtitle: 'Actifs fixes',
    add: 'Ajouter des actifs fixes',
    edit: 'Modifier les immobilisations',
    detail: 'Détails des immobilisations',
    disable: 'Faible immobilier',
    depreciation: 'Dépréciation accumulée',
    depreciationPercentage: '% Dépréciation accumulée',
    depreciation_financial: 'Amoraison financière',
    depreciation_fiscal: 'Amoraison budgétaire',
    depreciation_info: 'Informations sur les actifs',
    depreciation_values: "Calcul de l'amortissement",
    depreciable: 'Valeur pour se déprécier',
    enable_title: 'Récupérer les immobilisations',
    enable_confirm:
      'Voulez-vous vraiment récupérer lactif <strong>"{{number}} - {{name}}"</strong> qqui avait été licencié? * <br/><br/> <small>* Laction ne peut pas être annulée.</small>',
    subtitle_monts_and_records_assets: 'Somme des montants et des actifs',
    amount_and_assets_per_page: "Montant et actifs par page",
    amount_and_record_of_all_assets: "Montant et enregistrement de tous les actifs",
    totalMoney: 'Montant total',
    totalCount: 'Total des actifs',
    section: {
      disable: 'Détail de la victime',
      accountant: 'Comptable',
      assurance: 'Assurance',
      in_out: 'Entrées et sorties',
      bill: "Facture d'achat",
      buy: 'Acheter',
      customs_fields: 'Déclarations en douane',
      customFields: 'Champs personnalisés',
      general: 'Général',
      location: 'Emplacement',
      project: 'Projet',
      files: 'Records',
      form: 'Données',
      depreciation: 'Dépréciation',
      notes: 'Grades',
      historic: 'Enregistrement',
      codes: 'Codes',
      downloadQR: 'Téléchargement QR',
      downloadBarcode: 'Télécharger le code-barres',
      regenerateCode: 'Régénérer le code',
      customs_documents: 'Documents en douane',
      customs_documents_title: 'Documents en douane',
      codes: {
        title_qrUrl: "Code QR avec l'URL de l'actif",
        title_qrName: "Code QR avec le nom de l'actif",
        title_qrData: "Code QR avec les données de l'actif",
        title_barcode: "Code-barres avec le numéro de l'actif",
        codeLabel: 'Télécharger des codes',
        fields_data_asset: {
          name: 'Nom',
          number: 'Numéro',
          brand: 'Marque',
          model: 'Modèle',
          serie: 'Numéro de série',
          employee: 'Employé',
          location: 'Emplacement',
          createdAt: 'Date de création',
          updatedAt: 'Dernière mise à jour',
        },
        info: {
          qrUrl:
            "Ce code QR contient l'URL raccourcie de l'actif, redirigeant vers le système SAAF.",
          qrName: "Ce code QR est composé du compte, de la sous-catégorie et du numéro de l'actif.",
          qrData: "Ce code QR contient les informations suivantes sur l'actif en texte brut :",
          barcode:
            "Ce code-barres est composé du compte, de la sous-catégorie et du numéro de l'actif.",
        },
        format: {
          codeLabel: 'Étiquette du code',
          pdf: 'PDF',
          docx: 'DOCX',
          png: 'PNG',
          png_qr: 'PNG QR',
          png_barcode: 'PNG code-barres',
        },
      },
    },
    fields: {
      files: 'Records',
      consecutive: 'Consécutif',
      asset_level: 'Niveau des actifs',
      level: 'Niveau des actifs',
      account: 'Compte (Nom du)',
      accountKey: 'Compte (Clé)',
      billConcept: 'Concept dans la facture',
      billDate: 'Date de facture',
      billFolio: 'Folio de facture',
      billNumber: 'Numero de facture',
      dmsReference: 'Référence DMS',
      custodyNotes: 'Notes du bon de garde',
      custodyNotesHelp: 'Une ligne par élément remis avec l’actif (carte grise, clés, accessoires…)',
      brand: 'Marque',
      buyCondition: "Condition d'achat",
      buyDate: "Date d'achat",
      buyOrder: 'Bon de commande',
      approvalNumber: "Numéro d'approbation",
      createdAt: 'Date de creation',
      coin: 'Devise',
      costCenter: 'Central Central',
      country: 'Pays',
      description: 'La description',
      dollarAssetPrice: "Prix d'achat actif",
      insurable: 'Assurance',
      insuranceCarrier: "Compagnie d'assurance",
      insurancePercent: 'Pourcentage assuré',
      insurancePolicy: "Police d'assurance",
      financialDepreciation: 'Amoraison financière',
      fiscalDepreciation: 'Amoraison budgétaire',
      usefulLifeOriginal: 'Durée de vie utile',
      location: 'Emplacement',
      life: 'Utilisation du temps (années)',
      model: 'Modèle',
      name: 'Nom',
      number: 'Le numéro',
      physicalState: 'État physique',
      prefix: 'Préfixe',
      price: 'Prix',
      priceDollars: 'Prix en dollars',
      currentMonthDep: 'Mois de dép. Période en cours',
      totalMonthYearsDep: 'A. mois dep. dans les exercices à la fin de la précédente',
      totalMonthYearsDepAct: 'A. mois dep. dans les exercices à la actuel',
      totalMonthLife: 'Total des mois pour se déprécier',
      monthlyDepDollars: "Amoraison mensuelle de l'USD",
      monthlyDep: 'Dépréciation mensuelle',
      moi: 'M.O.I (recalculé)',
      exchange: 'Taux de change',
      project: 'Projet',
      projectPrice: 'Cout du projet',
      provider: 'Le fournisseur',
      serie: 'Numéro de série',
      startDate: 'Date de la demande',
      status: 'Statut',
      subaccount: 'Type',
      sublocation: 'Emplacement de niveau',
      asignedEmployeeDate: 'Date de responsable responsable',
      employee: 'Responsable',
      validated: 'Statut responsable',
      validatedDate: 'Date de validation responsable',
      depreciationName: 'Amoraison appliqué',
      remainingLife: 'La vie restante',
      endDate: 'Date des valeurs',
      lifeTime: 'Durée de vie (années)',
      currentDepreciation: 'Amoraison de la période actuelle',
      lastDepreciation: 'Démontation précédente',
      inpcStart: 'Acquisition INPC',
      inpcEnd: 'Inpc Use',
      factor: 'Facteur de mise à jour',
      lastDepreciationRecalculated: 'Période actuelle recalculée',
      totalDepreciation: 'Amoraison totale',
      depreciable: 'Valeur de remplacement net',
      img_asset: 'Actif',
      img_employee: 'Employé',
      customs_documents_pedimento_number: 'Numéro de pédimento',
      customs_documents_customs_key: 'Clé douanière',
      customs_documents_date: 'Date',
      customs_documents_pedimento_key: 'Clé de pédimento',
      customs_documents_import: 'Importation',
      customs_documents_quantity: 'Quantité',
      customs_documents_upload_files: 'Fichiers',
      notes: {
        text: 'Noter',
        createdBy: 'Créé par',
        createdAt: 'Date de creation',
        notSaved: "Boucle d'oreille",
        empty: "Aucune note n'a été ajoutée,",
      },
      historics: {
        field: 'Campagne',
        after: 'Nouvelle valeur',
        before: 'Valeur précédente',
        hide: 'Masquer les changements',
        show: 'Afficher les changements',
        date: 'Date',
        user: 'Utilisateur',
        status: 'Statut',
        empty: "Aucun changement n'a encore enregistré",
        statusName: {
          ACCEPTED: 'Accepté',
          REJECTED: 'Refusé',
          PENDING: "Boucle d'oreille",
        },
        buttonFilters: {
          showFilters: 'Show Filters',
          hideFilters: 'Hide Filters',
        },
        searchEditor: {
          consecutive: 'Consécutif',
          prefix: 'Préfixe',
          number: 'Le numérp',
          name: 'Nom',
          description: 'La description',
          account: 'Compte comptable',
          subAccount: 'Type',
          costCenter: 'Centre de couts',
          employee: 'Employé',
          provider: 'Le fournisseur',
          buyOrder: 'Bon de commande',
          customs_documents_pedimento_number: 'Numéro de pédimento',
          customs_documents_customs_key: 'Clé douanière',
          customs_documents_pedimento_key: 'Clé de pédimento',
        },
      },
      out: {
        get_in: 'Entrée active',
        get_out: 'Sortie active',
        createdAt: 'Date',
        outDate: 'Date de sortie',
        time_out: 'Days Out',
        isOut: 'Condition',
        is_in: 'Dans',
        is_out: 'Dehors',
        message: 'Message',
        acept_output: 'Accepter la sortie',
        reject_output: 'Rejeter la sortie',
        _user_request: 'Demandée par',
        _user_authorized: 'Autorisé',
        role_to_acept: 'Autorisation (rôle)',
        needs_authorization: 'Awed avec autorisation',
        message_required: 'Awed avec autorisation',
        out: 'Départ',
        in: 'Entrée',
        'reject out': 'Rejet de sortie',
        'acept out': 'Sortie accepte',
        'out request': 'Demande de sortie',
        status: 'Statut',
        _employee: 'Responsable',
      },
      disabled: 'Télécharger',
      disableReason: 'Moteur de Baja',
      disableDetail: 'Détail',
      disableAmount: 'Montant récupéré',
      disableDate: 'Date de décharge',
      refound: 'Perte / gain',
      hasPendingChanges: "Modifications à l'examen",
      _group: 'Groupes personnalisés',
      _extraDepreciations: 'Amortissements supplémentaires',
      _customsDocuments: 'Documents en douane',
    },
    searchEditor: {
      assets: 'Des atouts',
      id: 'Id',
      number: 'Le numéro',
      name: 'Nom',
      description: 'La description',
      accountType: 'Type de compte',
      assetType: "Type d'actif",
      centerCost: 'Centre de couts',
      nameEmployee: "Nom de l'employé",
      lastNameEmployee: "Nom de famille de l'employé",
      provider: 'Le fournisseur',
    },
    oldSearchEditor: {
      oldValues: 'Anciennes valeurs',
      id: 'Id',
      number: 'Le numéro',
      name: 'Nom',
      description: 'La description',
      contableAccount: 'Compte comptable',
      assetType: "Type d'actif",
      centerCost: 'Centre de couts',
      nameEmployee: "Nom de l'employé",
      lastnameEmployee: "Nom de famille de l'employé",
      provider: 'Le fournisseur',
    },
    changeSearchEditor: {
      changes: 'Changements',
      value: 'La peine',
    },
    tablesDepreciationColums: {
      year: 'Année',
      period: 'Période',
      monthsDepExercise: '#Mois amortis dans l’exercice',
      totalMonthsDepExercise: 'Total des mois amortis dans les exercices',
      totalMonthsToDep: 'Total des mois à déprécier',
      factor: 'Facteur',
      depMonthly: 'Amortissement Mensuel',
      depPeriod: 'Amortissement Période',
      percentajeDepPeriod: '% Amortissement Period',
      depAccumulated: 'Amortissement Accumulé',
      percentajeDepAccumulated: '% Amortissement Accumulé',
      valueToDepreciate: 'Valeur à amortir',
    },
  },

  menu: {
    dashboard: 'Tableau de bord',
    asset_level: 'Niveau des actifs',
    control_panel: 'Panneau de commande',
    configuration: 'Paramètre',
    users: 'Utilisateurs',
    notifications_config: 'Notifications',
    notifications_historic: 'Notifications',
    roles: 'Les rôles',
    groups: 'Groupes personnalisés',
    subcompanies: 'Gérer les entreprises',
    subcompanies_add: 'Ajouter une entreprise',
    assets: 'Actif',
    maintenance: 'Entretien',
    reports: 'Rapports',
    reports_depreciation: 'Dépréciation',
    reports_disabled: 'Bas',
    reports_historics: 'Enregistrement',
    import: 'Importer',
    custom_fields_employees: 'Les champs personnalisés',
    employees: 'Des employés',
    accounts: 'Comptes comptables',
    subaccounts: "Types d'actifs",
    depreciations: 'Dépréciation',
    costCenters: 'Centres de coûts',
    catalogs: 'Catalogues',
    inpc: 'Inpc',
    exchange: 'Taux de change',
    locations: 'Emplacements',
    projects: 'Projets',
    providers: 'Fournisseurs',
    actions: {
      logout: 'Fermer la session',
      update: 'Modifier mes informations',
      edit: '',
    },
    reports_employees_assets: 'Bons de prosedo',
    reports_ins_outs: 'Entrées et sorties',
    support: 'Aide et soutien',
    maintenance: 'Maintenance Alpha',
  },

  catalog: {
    physicalState: {
      name: 'État physique',
      elements: {
        excelent: 'Excellent',
        good: 'Bon',
        medium: 'Régulier',
        bad: 'Mal',
      },
    },
    country: {
      name: 'Pays',
      elements: {
        mex: 'Mexique',
        usa: "Etats unis d'Amérique",
      },
    },
    coin: {
      name: 'Devise',
      elements: {
        mxn: 'Pesos mexicains',
        usd: 'Dollars américains',
        eur: 'Euros',
      },
    },
    buyCondition: {
      name: "Condition d'achat",
      elements: {
        new: 'Nouveau',
        used: 'Utilisé',
      },
    },
    status: {
      name: 'Statut',
      elements: {
        depreciating: 'Dépréciation',
        not_depreciating: 'Ne pas se déprécier',
        in_construction: 'En construction',
      },
    },
    disableReason: {
      name: 'Moteur de Baja',
      elements: {
        sell: 'Vente',
        damange: 'Dégâts',
      },
    },
    prefix: {
      name: 'Préfixe',
    },
    depreciationCriteria: {
      name: "Critères d'amortissement",
      elements: {
        date: 'Date de la demande',
        month: 'Le mois prochain',
      },
    },
    insuranceCarrier: {
      name: "Compagnie d'assurance",
    },
    customs_documents_status: {
      name: 'Statut',
      elements: {
        temporary_importation: 'Importation temporaire',
        definitive_importation: 'importation finale',
        returned: 'Retourné',
        virtual: 'Virtuel',
      },
    },
  },

  dashboard: {
    title: 'Tableau de bord',
    showAssets: 'REGARDER',
    addAsset: 'AJOUTER UN ÉLÉMENT',
    assetsTotal: "Nombre d'actifs",
    amountTotal: 'Total',
    totalByAccounts: 'Actifs comptables',
    totalByCostCenters: 'Actifs du centre des coûts',
    amountByCostCenters: 'Coût des actifs par centre de coûts',
    totalByStatus: 'Assets de statut',
  },

  custom_employee_module: {
    // Para roles:
    title: 'Les champs personnalisés',
  },

  custom_employee: {
    // Para roles
    title: 'Les champs personnalisés',
  },

  custom_group: {
    // Para roles
    title: 'Groupes de champs personnalisés',
  },
  custom_fields: {
    // Para roles
    title: 'Les champs personnalisés',
  },
  custom_field: {
    // Para roles
    title: 'Fields personnalisés - champs',
    empity: 'Vide',
  },

  custom_fields_employees: {
    title: 'Les champs personnalisés',
    employees_title: 'Les champs personnalisés',
    edit: 'Modifier le champ personnalisé',
    add: 'Ajouter un champ personnalisé',
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      active: 'Actif',
      type: 'Type',
      description: 'La description',
    },
    add: {
      numeric: 'Numérique',
      coin: 'Coin',
      date: 'Pièce de monnaie',
      shortText: 'Texte court',
      largeText: 'Grand texte',
      dropDown: 'Menu déroulant',
      uniqueSelection: 'Sélection unique',
      multipleSelection: 'Sélection multiple',
      hour: 'Heure',
    },
    searchEditor: {
      key: 'Mot de passe',
      name: 'Nom',
      type: 'Type',
    },
  },
  notifications_config: {
    title: 'Configuration des notifications',
  },
  notification_config: {
    title: 'Configuration des notifications',
    edit: 'Modifier le profil de notification',
    add: 'Ajouter un profil de notification',
    description: 'La description',
    key: 'Code',
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      send_mail: 'Envoyer un e-mail',
      destinatarios: '# Destinataires',
      options: '# Options',
      active: 'Actif',
      type: 'Type',
      description: 'La description',
    },
    form: {
      general: 'Données générales',
      customFields: 'Notifications',
    },
    searchEditor: {
      key: 'Mot de passe',
      name: 'Nom',
      description: 'La description',
    },
  },

  notify: {
    assets: {
      add: 'Ajouter des actifs',
      disable: "Utilisation d'un actif",
      edit: 'Modifier un actif',
      edit_request: "Demander une édition d'actifs",
      edit_create_historic: 'Créer un changement historique',
      edit_accept: "Accepter l'édition Asset",
      edit_reject: "Rejeter l'édition d'actifs",
      restore: 'Récupérer actif',
      out: 'Sortie active',
      in: 'Entrée active',
      reject_out: 'Rejet de sortie actif',
      acept_out: "La sortie de l'actif  a été acceptée",
      out_request: 'Application pour la sortie des actifs',
    },
  },

  notification_historic: {
    title: 'Notifications',
    edit: 'Modifier le profil de notification',
    add: 'Ajouter un profil de notification',
    view_email: 'Voir e-mail',
    fields: {
      key: 'Mot de passe',
      subject: 'Aventure',
      name: 'Code',
      send_mail: 'Envoyer un e-mail',
      destinatarios: '# Destinataires',
      options: '# Options',
      active: 'Actif',
      date: 'Date',
      type: 'Type',
      description: 'La description',
    },
    searchEditor: {
      name: 'Code',
      subject: 'Aventure',
      destinatarios: '# Destinataires',
    },
  },
  employees: {
    title: 'Des employés',
    employees_title: 'Des employés',
    edit: 'Edit Employee',
    add: 'Ajouter un employé',
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      lastname: 'Le nom',
      email: 'Courrier électronique',
      position: 'Position',
      numberAssignedAssets: '# Assigned Assets',
      active: 'Actif',
      group: 'Custom Fields Group',
    },
    searchEditor: {
      key: 'Mot de passe',
      name: 'Nom',
      lastname: 'Le nom',
      email: 'Courrier électronique',
      position: 'Position',
    },
  },

  custodyVoucher: {
    signature: 'Signature du dépositaire',
    signatureHelp: 'Signez avec le doigt, un stylet ou la souris.',
    clear: 'Effacer la signature',
    downloadForPaper: 'Télécharger pour signer sur papier',
    signAndSave: 'Signer et enregistrer',
    withoutPrice: 'Sans prix',
    withPrice: 'Avec prix',
    custodian: 'Dépositaire',
    assets: 'Biens couverts',
    reviewHint:
      'Pour relire le document complet, téléchargez-le pour le signer sur papier.',
    signFromActions: 'Signer le bon de garde',
    signGeneral: 'Signer et enregistrer',
    newCustodianNotice:
      'Le bien a un nouveau dépositaire. Générez son bon dans le détail : ' +
      'Actions > Signer le bon de garde.',
    clearSearchToSign: 'Effacez la recherche pour signer le bon avec tous les biens.',
  },

  files: {
    locked: 'Signé',
    voucherCurrent: 'En vigueur',
    voucherPrevious: 'Antérieur',
    signedFor: 'Dépositaire',
    custodianUnknown: 'non enregistré',
    signedAt: 'Signé le',
    preview: 'Aperçu',
    name: 'Nom',
    default: 'Par défaut',
    actions: 'Actions',
    status: 'Statut',
    empty: 'Pas encore ajouté de fichiers',
    pending: 'Charger ...',
    uploading: 'Mise en charge...',
    uploaded: 'Chargé',
    fail: 'Échec',
    importing: 'Importation de données ...',
    imported: 'Données importées',
  },

  reports: {
    title: 'Rapports',
    fields: {
      accounts: 'Comptes',
      subaccounts: 'Les types',
      costCenters: 'Centres de coûts',
      employees: 'Des employés',
      providers: 'Fournisseurs',
      projects: 'Projets',
      depreciationType: "Type d'amortissement",
      endDate: 'Date de titres',
      status: 'Statut',
      disabled: 'Handicapé',
      physicalState: 'État physique',
      hasPendingChanges: "Modifications à l'examen",
      createdAt: 'Date de solicitude',
      reviewDate: 'Date de révision',
      buttonFilters: {
        showFilters: 'Show Filters',
        hideFilters: 'Hide Filters',
      },
    },
    values: {
      depreciationType: {
        fiscal: 'Fiscal',
        financial: 'Financier',
      },
    },
    depreciation: {
      title: "Rapport d'amortissement actif",
      subtitle: "Rapport d'amortissement actif",
    },
    disabled: {
      title: 'Rapport à faible actif',
      subtitle: 'Rapport à faible actif',
    },
    ins_outs: {
      title: 'Rapport de médicament et de production',
      subtitle: "Rapport d'entrée et de sortie",
    },
    employeesAssets: {
      hideAssets: 'Masquer les actifs attribués',
      showAssets: 'Afficher les actifs attribués',
      assigned: 'Actifs attribués',
      title: 'Bons de prosedo',
      subtitle: 'Bons de prosedo',
    },
    historics: {
      hideAssets: 'Masquer les changements',
      showAssets: 'Afficher les changements',
      assigned: 'Actifs attribués',
      title: 'Histoire des changements dans les actifs',
      subtitle: 'Histoire des changements dans les actifs',
      fields: {
        status: 'Statut',
        createdAt: 'Demande',
        reviewDate: 'Examiné',
        createdBy: 'Demande',
        reviewedBy: 'Examiné',
        key: 'Mot de passe',
        number: 'Le numéro',
        location: 'Emplacement',
        name: 'Actif',
        account: 'Compte comptable',
        sub_account: "Type d'actif",
        costCenter: 'Centre de couts',
        asigned: 'Responsable',
        asigned_status: 'Responsable',
        // asset:{
        // number
        // name
        // description
        // model
        // serie
        //}
      },
    },
    searchEditor: {
      assets: 'Des atouts',
      id: 'Id',
      number: 'Le numéro',
      name: 'Nom',
      description: 'La description',
      accountType: 'Type de compte',
      assetType: "Type d'actif",
      centerCost: 'Centre de couts',
      nameEmployee: "Nom de l'employé",
      lastNameEmployee: "Nom de famille de l'employé",
      provider: 'Le fournisseur',
    },
    oldSearchEditor: {
      oldValues: 'Anciennes valeurs',
      id: 'Id',
      number: 'Le numéro',
      name: 'Nom',
      description: 'La description',
      contableAccount: 'Compte comptable',
      assetType: "Type d'actif",
      centerCost: 'Centre de couts',
      nameEmployee: "Nom de l'employé",
      lastnameEmployee: "Nom de famille de l'employé",
      provider: 'Le fournisseur',
    },
    changeSearchEditor: {
      changes: 'Changements',
      field: 'Fidèle',
      value: 'La peine',
    },
  },

  import: {
    title: "Module d'importation",
    unassigned: 'non attribuée',
    list_subtitle: "Module d'importation",
    form_subtitle: "Importer des données à partir d'un fichier",
    reimport_title: 'Réimportation',
    reimport:
      "¿Réimporter dans le module:<strong> {{name}} </strong> '? * <br /> <br /> <All> * L'action ne peut pas être annulée. </ Mall> ",
    error: {
      verify: "Sélectionnez un fichier pour l'importer",
      fileType: 'Erorr Lors de la sélection du fichier, seuls CSV est autorisé.',
      importing:
        "Une erreur s'est produite lorsque vous essayez d'importer le fichier, le fichier peut être endommagé ou n'a pas le format correct,",
    },
    modules: {
      assets: 'Actif',
      providers: 'Fournisseurs',
      projects: 'Projets',
      cost_centers: 'Centres de coûts',
      cuenta_contable: 'Comptes comptables',
      tipo_activo: "Types d'actifs",
      custom_employees: 'Employés des champs personnalisés',
      employees: 'Des employés',
      locations: 'Emplacements',
    },
    fields: {
      files: 'Fichier, archive',
      module: 'Module',
      createdAt: "Date d'importation",
      status: 'Statut',
      updated: '# Records mis à jour',
      inserted: '# Créé des enregistrements',
      fail: '# Échec des enregistrements',
      warnings: '# Avertissements',
      import: 'Réimportation',
      selectHeaders: 'Sélectionnez les en-têtes',
      actions: 'Actions',
      file: 'Fichier, archive',
      download: 'Télécharger CSV',
      csvTemplateAssets: 'Modèle CSV actif',
    },
    showDetailsFields: {
      showDetails: 'Afficher les détails',
      hideDetails: 'Cacherles détails',
      new: 'Nouveau',
      success: 'Succéss',
      warning: 'Advertissements',
      wrongs: 'Erreurs',
    },
    searchEditor: {
      assets: 'Assets',
      provider: 'Provider',
      projects: 'Projects',
      costCenter: 'Cost center',
      ledgerAccounts: 'Contable counts',
      typeAssets: 'Type of assets',
      customFieldsEmployees: 'Custom fields employees',
      employees: 'Employees',
      locations: 'Locations',
    },
  },
  exchanges: {
    title: "Taux d'échange",
  },
  exchange: {
    title: "Taux d'échange",
    exchange_title: "Taux d'échange",
    edit: 'Modifier le taux de change',
    add: 'Ajouter le taux de change',
    fields: {
      fromCurrency: "Devise d'origine",
      toCurrency: 'Devise de destination',
      value: 'La peine',
      date: 'Date',
    },
  },

  cost_centers: {
    title: 'Centres de coûts',
  },

  costCenters: {
    title: 'Centres de coûts',
    costCenters_title: 'Centres de coûts',
    edit: 'Modifier le centre de coûts',
    add: 'Ajouter un centre de coûts',
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      description: 'La description',
      active: 'Actif',
    },
    searchEditor: {
      key: 'Mot de passe',
      name: 'Nom',
      description: 'La description',
    },
  },

  providers_clients: {
    title: 'Fournisseurs',
  },

  catalogs: {
    title: 'Catalogues',
    catalogs_title: 'Catalogues',
    edit: 'Modifier le catalogue',
    form: {
      general: 'Données générales',
      elements: 'Éléments de catalogue',
    },
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      value: 'La peine',
      elements: 'Articles',
      active: 'Actif',
    },
    searchEditor: {
      key: 'Mot de passe',
    },
  },

  accounts: {
    title: "Comptables comptables et types d'actifs",
    accounts_title: 'Comptes comptables',
    edit: 'Modifier le compte comptable',
    add: 'Ajouter un compte comptable',
    form: {
      general: 'Données générales',
      depreciations: 'Dépréciation',
      customFields: 'Champs personnalisés',
    },
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      description: 'La description',
      active: 'Actif',
      fiscalDepreciation: 'Amoraison budgétaire',
      financialDepreciation: 'Amoraison financière',
      customFields: {
        key: 'Clé',
        label: 'Étiquette',
        unique: 'Champ unique',
        dependent: 'Valeur dépendante',
      },
    },
    searchEditor: {
      key: 'Mot de passe',
      name: 'Nom',
      description: 'La description',
    },
  },

  subaccounts: {
    subaccounts_title: "Types d'actifs",
    edit: "Modifier le type d'actif",
    add: "Ajouter un type d'actif",
    form: {
      general: 'Données générales',
      depreciations: 'Dépréciation',
      customFields: 'Champs personnalisés',
    },
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      description: 'La description',
      active: 'Actif',
      parent: 'Compte comptable',
      fiscalDepreciation: 'Amoraison budgétaire',
      financialDepreciation: 'Amoraison financière',
      customFields: {
        key: 'Clé',
        label: 'Étiquette',
      },
    },
    searchEditor: {
      key: 'Mot de passe',
      name: 'Nom',
      description: 'La description',
      parent: 'Compte comptable',
    },
  },

  depreciations: {
    title: 'Dépréciation',
    depreciations_title: 'Dépréciation',
    edit: 'Modifier la dépréciation',
    add: 'Ajouter la dépréciation',
    form: {
      general: 'Données générales',
      percents: "Pourcentages d'amortissement",
    },
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      active: 'Actif',
      maximumAmount: 'Montant maximum à déprécier',
      maximumPercent: 'Pourcentage maximum pour se déprécier',
      criteria: 'Critère',
      year: 'An',
      percentage: 'Pourcentage',
      total: 'Total',
      monthslastyear: "Mois l'année dernière",
    },
    searchEditor: {
      key: 'Mot de passe',
      name: 'Nom',
    },
  },

  inpc: {
    inpc_title: 'Index national des prix à la consommation',
    title: 'Inpc',
    edit: 'Modifier INPC',
    add: 'Ajouter INPC',
    form: {
      general: 'Données générales',
      percents: "Pourcentages d'amortissement",
    },
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      active: 'Actif',
      maximumAmount: 'Montant maximal amortirable',
      criteria: 'Critère',
      year: 'An',
      percentage: 'Pourcentage',
      total: 'Total',
    },
    searchEditor: {
      year: 'An',
    },
  },

  locations: {
    title: 'Emplacements',
    locations_title: 'Emplacements',
  },

  projects: {
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      amount: 'Montant',
      active: 'Actif',
    },
    searchEditor: {
      key: 'Mot de passe',
      name: 'Nom',
      amount: 'Montant',
      active: 'Actif',
    },
    title: 'Projets',
    edit: 'Modifier le projet',
    add: 'Ajouter le projet',
  },
  asset_level: {
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      max_time: 'Maximo Days Out',
      message_required: "Vous avez besoin d'un message",
      can_withdrawn: 'Tu peux y aller',
      role_to_acept: "Nécessite l'acceptation de",
      active: 'Actif',
    },
    searchEditor: {
      key: 'Key code',
      name: 'Name',
      amount: 'Montant',
    },
    title: 'Niveau des actifs',
    edit: "Modifier le niveau d'actif",
    add: "Ajouter un niveau d'actif",
  },
  ins_outs: {
    title: 'Entrées et sorties',
  },

  providers: {
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      mail: 'Courrier électronique',
      telephone: 'Téléphone',
      rfc: 'RFC',
      active: 'Actif',
    },
    searchEditor: {
      key: 'Mot de passe',
      name: 'Nom',
      mail: 'Courrier électronique',
      telephone: 'Téléphone',
      rfc: 'RFC',
    },
    title: 'Fournisseurs',
    edit: 'Modifier le fournisseur',
    add: 'Ajouter le fournisseur',
  },

  mantenimiento: {
    title: 'Entretien',
  },
  mantenimiento_module: {
    title: 'Module de maintenance (extra)',
    edit: 'Éditer',
    add: 'Ajouter à la maintenance',
    fields: {
      key: 'Mot de passe',
      name: 'Nom',
      mail: 'Courrier électronique',
      telephone: 'Téléphone',
      rfc: 'RFC',
      active: 'Actif',
    },
  },

  asset_employeePDF: {
    title: 'Bon de sécurité',
    date: 'Date',
    employee: 'Employé',
    position: 'Positionner',
    id: "Clé de l'employé",
    table: {
      number: 'Le numéro',
      name: 'Nom',
      brand: 'Marque',
      model: 'Modèle',
      serie: 'Numéro de série',
    },
    message: {
      title: "J'ai reçu le matériel mentionné ci-dessous :",
      content:
        "Dont je m'engage à prendre soin, à maintenir en bon état et à utiliser uniquement et exclusivement pour les questions liées à mon activité professionnelle. En cas de perte, de détérioration ou de mauvaise utilisation, je suis responsable du paiement des frais de réparation ou de remplacement de l'équipement.",
    },
    receive: 'Reçoit',
    out: {
      title: 'Entrées et sorties',
      date: 'Date de solicitude',
      outDate: 'Date de sortie',
      max_time: "Nombre maximum de jours d'absence",
      outDays: 'Jours dehors',
      isOut: {
        title: 'Condition',
        outside: 'Dehors',
        indoors: "À l'intérieur",
        onHold: "En attente d'autorisation",
      },
      employee: 'Responsable',
      user_request: 'Demandée par',
      user_authorized: 'Autorisé',
      message: 'Message',
    },
  },
  info: {
    tooltip: {
      asset_module: {
        sum_of_amounts_and_records:
          "Les montants calculés sont basés sur le taux de change enregistré pour chaque actif. Si le taux de change n'est pas attribué, une valeur par défaut de 1 sera utilisée.",
      },
    },
  },
};



// WEBPACK FOOTER //
// src/locales/fr.js